import { buildButtonClickPayload } from '../buildPayloads/buildButtonClickPayload.js';
export const trackButtonClick = (params) => buildButtonClickPayload(params);
//# sourceMappingURL=trackButtonClick.js.map